module.exports = __webpack_public_path__ + "static/media/logoWhite.11d3a52c.svg";